<template>
  <div>
    <page-table ref="pageTable" :init-fetch="true" :loading="tableLoading" :columns="tableColumns"
                :page-total="pageTotal" :table-data="tableData" :show-create-btn="true" create-btn-title="新建文章"
                @btnHandler="btnHandler" @fetchData="fetchData">
      <Button>审核</Button>
      <template slot="searchForm">
        <FormItem class="margin-bottom-0">
          <Select v-model="params.cat_ids" multiple filterable :max-tag-count="2" style="width:300px" placeholder="选择文章分类">
            <Option v-for="item in categoryList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem class="margin-bottom-0">
          <Input v-model="params.title" placeholder="文章标题" style="width: 320px;"></Input>
        </FormItem>
        <FormItem class="margin-bottom-0">
          <Select v-model="params.is_tops" clearable :max-tag-count="2" style="width: 100px;" placeholder="是否推荐">
            <Option :value="0">未推荐</Option>
            <Option :value="1">已推荐</Option>
          </Select>
        </FormItem>
        <FormItem class="margin-bottom-0">
          <Select v-model="params.published" clearable :max-tag-count="2" style="width: 100px;" placeholder="是否审核">
            <Option :value="1">已审核</Option>
            <Option :value="2">未审核</Option>
          </Select>
        </FormItem>
      </template>

      <template slot-scope="{ row, index }" slot="cat_name">
        <Tag color="volcano" @click.native="sarchCategoryHandler(row)" style="cursor: pointer">{{row.category && row.category.title }}</Tag>
      </template>

      <template slot-scope="{row, index}" slot="top_hot">
        <Tag v-if="row.is_top" color="primary">置顶</Tag>
        <Tag v-if="row.is_hot" color="error">推荐</Tag>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <Poptip v-if="!row.publish_time" confirm title="确定通过审核吗?" placement="left" style="margin-right: 5px" @on-ok="btnHandler('examine', row)"
                @on-cancel="btnHandler('cancel', row)" transfer>
          <Button  size="small" icon="ios-checkmark-circle"></Button>
        </Poptip>

        <Tooltip content="编辑" placement="top" transfer>
          <Button type="info" size="small" icon="md-create" style="margin-right: 5px" @click="btnHandler('edit', row)"/>
        </Tooltip>
        <Poptip confirm title="确定要删除吗?" placement="left" @on-ok="btnHandler('delete', row)"
                @on-cancel="btnHandler('cancel', row)" transfer>
          <Button type="warning" size="small" icon="md-trash"></Button>
        </Poptip>
      </template>
    </page-table>

    <Modal width="900" :title="formData.title" v-model="formData.visible" @on-ok="onSubmit">
      <Form label-width="100">
        <FormItem v-for="item in formData.fields" :key="item.key" :label="item.label">
          <Input v-if="item.type === 'input'" v-model="formData.data[item.key]"/>
          <Select v-if="item.type === 'select'" v-model="formData.data[item.key]" clearable filterable >
            <Option v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></Option>
          </Select>
          <tinymce v-if="item.type === 'editor'" v-model="formData.data[item.key]" ></tinymce>
          <i-switch v-if="item.type === 'switch'" v-model="formData.data[item.key]" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import pageTable from '../../components/pageTable/index'
import { deleteArticle, examineArticle, getArticleList, getCategoryList, saveArticle } from '../../api/article'
import tinymce from '../../components/tinymce/index'

export default {
  name: 'articleList',
  components: { pageTable, tinymce },
  data () {
    return {
      params: {
        title: '',
        cat_ids: [],
        is_tops: [],
        published: 0
      },
      tableLoading: false,
      tableColumns: [
        { title: 'id', key: 'id', width: 60 },
        { title: '所属分类', key: 'cat_name', slot: 'cat_name', width: 140 },
        { title: '标题', key: 'title', minWidth: 200 },
        { title: '推荐/置顶', key: 'top_hot', width: 100, slot: 'top_hot' },
        { title: '发布时间', key: 'publish_time', align: 'right', width: 160 },
        { title: '创建时间', key: 'create_time', align: 'right', width: 160 },
        { title: '操作', slot: 'action', width: 100, align: 'center', fixed: 'right' }
      ],
      pageTotal: 0,
      tableData: [],
      formData: {
        visible: false,
        title: '',
        fields: [
          { label: '文章标题', key: 'title', type: 'input' },
          { label: '文章分类', key: 'cat_id', type: 'select' },
          { label: '文章内容', key: 'content', type: 'editor' },
          { label: '是否热门', key: 'is_hot', type: 'switch' }
        ],
        data: {}
      },
      categoryList: []
    }
  },
  mounted () {
    getCategoryList({ page_size: 50 }).then(({ data }) => {
      this.categoryList = data.data
    })
  },
  methods: {
    fetchData (page) {
      this.tableLoading = true
      const params = { ...this.params, ...page }
      if (!params.published) params.published = 0
      params.type = 1
      getArticleList(params).then(({ data }) => {
        this.tableData = data.data
        this.pageTotal = data.total
      }).finally(() => {
        this.tableLoading = false
      })
    },
    btnHandler (e, row) {
      this[e](row)
    },
    edit (row) {
      this.formData.visible = true
      this.formData.title = '修改文章'
      this.formData.data = { ...row }
    },
    new () {
      this.formData.visible = true
      this.formData.title = '新增文章'
      this.formData.data = {}
    },
    delete (row) {
      deleteArticle({ id: row.id }).then(() => {
        this.$Message.success({
          content: '删除成功~'
        })
      }).finally(() => {
        this.fetchData()
      })
    },
    // 审核
    examine (row) {
      examineArticle({ id: row.id }).then(() => {
        this.$Message.success({
          content: '审核成功~'
        })
      }).finally(() => {
        this.fetchData()
      })
    },
    cancel () {
    },
    sarchCategoryHandler (row) {
      console.log(row)
      this.params.cat_ids = [ row.cat_id * 1 ]
      this.fetchData()
    },
    onSubmit () {
      saveArticle({ ...this.formData.data }).then(() => {
        this.$Message.success({
          content: '保存成功~'
        })
        this.fetchData()
      }).finally(() => {
      })
    }

  }
}
</script>
